import apiPaths from '../api-paths';

export default {
  listByClosedMonthOriginal({ original }) {
    return axios.get(`${ apiPaths.BOOKKEEPING }/closed-month-requests?closed_month_original=${ original }`);
  },
};
